import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';
import { SettingsService } from '../../services/settings.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'mpf-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss']
})
export class SettingsDialogComponent implements OnInit {
  public language: string;
  public supportedLanguages: string[];

  public currency;
  public supportedCurrencies: string[];

  constructor(
    private dialogRef: MatDialogRef<SettingsDialogComponent>,
    private settings: SettingsService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.language = this.settings.getLanguage();
    this.supportedLanguages = this.settings.getSupportedLanguages();
    this.supportedCurrencies = this.settings.getSupportedCurrencies();
    this.currency = this.settings.getCurrency();
  }

  async apply() {
    this.translate.use(this.language);
    this.dialogRef.close();

    this.settings.setLanguage(this.language);
    this.settings.setCurrency(this.currency);

    // Save cart items
    const { items } = window.Snipcart.store.getState().cart.items;

    // get items before they get resetted when we set the new currency
    let itemsWithNewCurrency = items.map(item => {
      return {
        ...item,
        price: environment.mapify.prices[this.currency][item.id]
      };
    });

    // Remove all items (by setting the new cart currency)
    window.Snipcart.api.session.setCurrency(this.currency.toLowerCase());

    await Promise.all(itemsWithNewCurrency.map(item => window.Snipcart.api.cart.items.add(item)));

    // reload is required otherwise Size/Layout items are not refreshed with the new currency/values! (broken angular change detection)
    location.reload(true);
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/components/settings-dialog/settings-dialog.component.ts